import { render } from "./AddProfile.vue?vue&type=template&id=79749ff4&ts=true"
import script from "./AddProfile.vue?vue&type=script&lang=ts"
export * from "./AddProfile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__